var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConditions = function SvgConditions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.899,
    height: 20.315,
    viewBox: "0 0 13.899 20.315",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(-1525.5 -584.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_72",
    "data-name": "Line 72",
    fill: "#b2b2b2",
    d: "M2.591.854H-.082A.744.744 0 0 1-.75.052a.744.744 0 0 1 .668-.8h2.673a.744.744 0 0 1 .668.8.744.744 0 0 1-.668.802z",
    transform: "translate(1528.121 602.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_73",
    "data-name": "Line 73",
    fill: "#b2b2b2",
    d: "M2.591.854H-.082A.744.744 0 0 1-.75.052a.744.744 0 0 1 .668-.8h2.673a.744.744 0 0 1 .668.8.744.744 0 0 1-.668.802z",
    transform: "translate(1528.121 591.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_74",
    "data-name": "Line 74",
    fill: "#b2b2b2",
    d: "M2.591.854H-.082A.744.744 0 0 1-.75.052a.744.744 0 0 1 .668-.8h2.673a.744.744 0 0 1 .668.8.744.744 0 0 1-.668.802z",
    transform: "translate(1528.121 597.278)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    fill: "none",
    width: 6.415,
    height: 1.069,
    rx: 0.535,
    transform: "translate(1531.38 591.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_266_-_Outline",
    "data-name": "Rectangle 266 - Outline",
    fill: "#b2b2b2",
    d: "M.638.1a.535.535 0 0 0 0 1.069h5.346a.535.535 0 0 0 0-1.069H.638m0-1.6h5.346a2.138 2.138 0 1 1 0 4.277H.638a2.138 2.138 0 0 1 0-4.277z",
    transform: "translate(1531.277 591.346)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    fill: "none",
    width: 6.415,
    height: 1.069,
    rx: 0.535,
    transform: "translate(1531.38 602.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_268_-_Outline",
    "data-name": "Rectangle 268 - Outline",
    fill: "#b2b2b2",
    d: "M.638.1a.535.535 0 0 0 0 1.069h5.346a.535.535 0 0 0 0-1.069H.638m0-1.6h5.346a2.138 2.138 0 1 1 0 4.277H.638a2.138 2.138 0 0 1 0-4.277z",
    transform: "translate(1531.277 602.038)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    fill: "none",
    width: 6.415,
    height: 1.069,
    rx: 0.535,
    transform: "translate(1531.38 596.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_270_-_Outline",
    "data-name": "Rectangle 270 - Outline",
    fill: "#b2b2b2",
    d: "M.638.1a.535.535 0 0 0 0 1.069h5.346a.535.535 0 0 0 0-1.069H.638m0-1.6h5.346a2.138 2.138 0 1 1 0 4.277H.638a2.138 2.138 0 0 1 0-4.277z",
    transform: "translate(1531.277 596.692)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    fill: "none",
    width: 2.138,
    height: 2.138,
    rx: 1,
    transform: "translate(1527.104 586.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_269_-_Outline",
    "data-name": "Rectangle 269 - Outline",
    fill: "#b2b2b2",
    d: "M1.173.1a1.069 1.069 0 1 0 1.069 1.073A1.069 1.069 0 0 0 1.173.1m0-1.6A2.673 2.673 0 1 1-1.5 1.173 2.676 2.676 0 0 1 1.173-1.5z",
    transform: "translate(1527 586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_75",
    "data-name": "Line 75",
    fill: "#b2b2b2",
    d: "M.052 13.684a.8.8 0 0 1-.8-.8V.052a.8.8 0 0 1 1.6 0v12.83a.8.8 0 0 1-.8.802z",
    transform: "translate(1528.121 589.794)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConditions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conditions.9b8a532b.svg";
export { ForwardRef as ReactComponent };